export default __webpack_public_path__ + "static/char-s-30-zh-Hans-50087ade03b3078ac2f573d99d282886.webp";